import { Col, Form, FormInstance, Input, Row } from 'antd';
import styles from './SettingsPage.module.scss';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import userApi from '../../api/UserApi';
import LayoutComponent from '../../components/LayoutComponent/LayoutComponent';
import CustomContext from '../../context/CustomContext';
import { CurrentUser } from '../../model/entities';
import notificationService from '../../services/NotificationService';
import WrapperComponent from '../../components/WrapperComponent/WrapperComponent';
import SettingsWorkDocsComponent from './SettingsWorkDocsComponent/SettingsWorkDocsComponent';
import SettingsAutodeskComponent from './SettingsAutodeskComponent/SettingsAutodeskComponent';

class SettingsPage extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;
    formRef = React.createRef<FormInstance>();

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    /** METHODS **/

    init = async () => {
        try {
            await this.get();
        } catch (error) {
            notificationService.displayError(error, this.props.intl);
        }
    };

    get = async () => {
        const user = await userApi.getCurrent();

        this.setState({ user });
        this.formRef.current!.setFieldsValue(user);
    };

    /*** COMPONENTS ***/

    renderContent = (): React.ReactElement | undefined => {
        return this.renderForm();
    };

    renderForm = (): React.ReactElement | undefined => {
        return (
            <Form ref={this.formRef} colon={false} layout="vertical">
                <Row gutter={[28, 0]}>
                    <Col span={12}>
                        <Form.Item label={<FormattedMessage id="settings.email" />} name="email">
                            <Input size="large" disabled className={styles.field} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[28, 0]}>
                    <Col span={12}>
                        <Form.Item label={<FormattedMessage id="settings.firstName" />} name="firstName">
                            <Input size="large" disabled className={styles.field} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label={<FormattedMessage id="settings.lastName" />} name="lastName">
                            <Input size="large" disabled className={styles.field} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        );
    };

    renderPlatforms = (): React.ReactElement | undefined => {
        const { user } = this.state;

        return (
            <>
                <h2>
                    <FormattedMessage id="settings.platforms" />
                </h2>
                <div>{user && <SettingsWorkDocsComponent user={user} />}</div>
                <div>{user && <SettingsAutodeskComponent user={user} />}</div>
            </>
        );
    };

    render() {
        return (
            <LayoutComponent pageId="settings">
                <WrapperComponent title={<FormattedMessage id="settings.title" />}>
                    {this.renderContent()}
                    {this.renderPlatforms()}
                </WrapperComponent>
            </LayoutComponent>
        );
    }
}
export default injectIntl(SettingsPage);

interface Props extends WrappedComponentProps {}

interface State {
    user?: CurrentUser;
    saving?: boolean;
}
